import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { listActiveVendors } from '../../api/vendors';
import { Select } from '../ui/Input';

export default function VendorPicker({ value, onChange, placeholder = 'Select vendor...', ...rest }) {
  const { data, isLoading } = useQuery({
    queryKey: ['vendors', 'active'],
    queryFn: listActiveVendors,
    staleTime: 60_000,
  });

  return (
    <Select
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value ? Number(e.target.value) : null)}
      disabled={isLoading}
      {...rest}
    >
      <option value="">{isLoading ? 'Loading...' : placeholder}</option>
      {(data || []).map((v) => (
        <option key={v.id} value={v.id}>
          {v.name}
        </option>
      ))}
    </Select>
  );
}
